module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-5.571cef41.png";